import { gql } from '@efficiently/client-core-graphql-models';

export const DETECT_PLAN_INTERIOR = gql(`
	mutation DetectPlanInterior($planItemId: String!) {
		detectPlanInterior(planItemId: $planItemId) {
			...PlanDetectionRunFields
		}
	}
`);
